import EntityBase from '@/data/EntityBase';

import { Map } from 'immutable';

export default class PlanState extends EntityBase({
  features: new Map(),
}) {}
